// OTOMATİK ÜRETİLDİ — Sarraf mobil uygulamasının koda gömülü varsayılanlarından
// birebir çıkarıldı. Kaynak:
//   SARRAF/app/sarraf/lib/config/varsayilan_listeler.dart
//   SARRAF/app/sarraf/lib/utils/hesap_units.dart
//
// "Uygulamadaki mevcut listeleri yükle" butonu bu veriyi forma basar.
// Mobil tarafta da aynı liste yedek olarak durur; bu dosya yalnızca paneli besler.

export const VARSAYILAN_MOBIL_AYAR = {
  "apiUrl": "https://ukba-kasa.vercel.app/api/prices",
  "sayfalar": {
    "sarrafiye": {
      "baslik": "Sarrafiye",
      "gorunur": true,
      "birimler": [
        {
          "unit": "Eski Ziynet Çeyrek",
          "webKey": "Eski Ziynet Çeyrek"
        },
        {
          "unit": "Yeni Ziynet Çeyrek",
          "webKey": "Yeni Ziynet Çeyrek"
        },
        {
          "unit": "Eski Ziynet Yarım",
          "webKey": "Eski Ziynet Yarım"
        },
        {
          "unit": "Yeni Ziynet Yarım",
          "webKey": "Yeni Ziynet Yarım"
        },
        {
          "unit": "Eski Ziynet Tam",
          "webKey": "Eski Ziynet Tam"
        },
        {
          "unit": "Yeni Ziynet Tam",
          "webKey": "Yeni Ziynet Tam"
        },
        {
          "unit": "Eski Ziynet 2.5'lu Gremse",
          "webKey": "Eski Ziynet 2.5'lu Gremse"
        },
        {
          "unit": "Yeni Ziynet 2.5'lu Gremse",
          "webKey": "Yeni Ziynet 2.5'lu Gremse"
        },
        {
          "unit": "Eski Ziynet Beşli",
          "webKey": "Eski Ziynet Beşli"
        },
        {
          "unit": "Yeni Ziynet Beşli",
          "webKey": "Yeni Ziynet Beşli"
        },
        {
          "unit": "Cumhuriyet Ata Çeyrek",
          "webKey": "Cumhuriyet Ata Çeyrek"
        },
        {
          "unit": "Cumhuriyet Ata Yarım",
          "webKey": "Cumhuriyet Ata Yarım"
        },
        {
          "unit": "Cumhuriyet Ata",
          "webKey": "Cumhuriyet Ata"
        },
        {
          "unit": "Cumhuriyet Ata 2.5'lu",
          "webKey": "Cumhuriyet Ata 2.5'lu Gremse"
        },
        {
          "unit": "Cumhuriyet Ata Beşli",
          "webKey": "Cumhuriyet Ata Beşli"
        },
        {
          "unit": "Reşat Çeyrek",
          "webKey": "Reşat Çeyrek"
        },
        {
          "unit": "Reşat Yarım",
          "webKey": "Reşat Yarım"
        },
        {
          "unit": "Reşat",
          "webKey": "Reşat"
        },
        {
          "unit": "Reşat 2.5'lu",
          "webKey": "Reşat 2.5'lu Gremse"
        },
        {
          "unit": "Reşat Beşli",
          "webKey": "Reşat Beşli"
        }
      ]
    },
    "gramAltin": {
      "baslik": "Gram Altın",
      "gorunur": true,
      "birimler": [
        {
          "unit": "1 Gram 22 Ayar",
          "webKey": "1 Gram 22 Ayar"
        },
        {
          "unit": "0.50 Gram 22 Ayar",
          "webKey": "0.50 Gram 22 Ayar"
        },
        {
          "unit": "0.25 Gram 22 Ayar",
          "webKey": "0.25 Gram 22 Ayar"
        },
        {
          "unit": "1 Gram 24 Ayar",
          "webKey": "1 Gram 24 Ayar"
        },
        {
          "unit": "0.50 Gram 24 Ayar",
          "webKey": "0.50 Gram 24 Ayar"
        },
        {
          "unit": "0.25 Gram 24 Ayar",
          "webKey": "0.25 Gram 24 Ayar"
        },
        {
          "unit": "2.50 Gram 24 Ayar",
          "webKey": "2.50 Gram 24 Ayar"
        },
        {
          "unit": "5 Gram 24 Ayar",
          "webKey": "5 Gram 24 Ayar"
        },
        {
          "unit": "10 Gram 24 Ayar",
          "webKey": "10 Gram 24 Ayar"
        },
        {
          "unit": "20 Gram 24 Ayar",
          "webKey": "20 Gram 24 Ayar"
        },
        {
          "unit": "50 Gram 24 Ayar",
          "webKey": "50 Gram 24 Ayar"
        },
        {
          "unit": "100 Gram 24 Ayar",
          "webKey": "100 Gram 24 Ayar"
        }
      ]
    },
    "doviz": {
      "baslik": "Döviz",
      "gorunur": true,
      "birimler": [
        {
          "shortUnit": "USD/TRY",
          "longUnit": "Amerikan Doları",
          "webKey": "USD - Amerikan Doları"
        },
        {
          "shortUnit": "EUR/TRY",
          "longUnit": "Euro",
          "webKey": "EUR - Euro"
        },
        {
          "shortUnit": "GBP/TRY",
          "longUnit": "İngiliz Sterlini",
          "webKey": "GBP - İngiliz Sterlini"
        },
        {
          "shortUnit": "CHF/TRY",
          "longUnit": "İsviçre Frangı",
          "webKey": "CHF - İsviçre Frangı"
        },
        {
          "shortUnit": "AUD/TRY",
          "longUnit": "Avustralya Doları",
          "webKey": "AUD - Avustralya Doları"
        },
        {
          "shortUnit": "CAD/TRY",
          "longUnit": "Kanada Doları",
          "webKey": "CAD - Kanada Doları"
        },
        {
          "shortUnit": "SAR/TRY",
          "longUnit": "Suudi Arabistan Riyali",
          "webKey": "SAR - Suudi Arabistan Riyali"
        },
        {
          "shortUnit": "AED/TRY",
          "longUnit": "B.A.E Dirhemi",
          "webKey": "AED - Birleşik Arap Emirlikleri Dirhemi"
        },
        {
          "shortUnit": "QAR/TRY",
          "longUnit": "Katar Riyali",
          "webKey": "QAR - Katar Riyali"
        },
        {
          "shortUnit": "JOD/TRY",
          "longUnit": "Ürdün Dinarı",
          "webKey": "JOD - Ürdün Dinarı"
        },
        {
          "shortUnit": "KWD/TRY",
          "longUnit": "Kuveyt Dinarı",
          "webKey": "KWD - Kuveyt Dinarı"
        },
        {
          "shortUnit": "USD/KG",
          "longUnit": "Dolar/KG",
          "webKey": "USD/KG"
        },
        {
          "shortUnit": "EUR/KG",
          "longUnit": "Euro/KG",
          "webKey": "EUR/KG"
        }
      ]
    },
    "gumus": {
      "baslik": "Gümüş",
      "gorunur": true,
      "birimler": [
        {
          "unit": "5 Gram Paketli Granül Gümüş",
          "webKey": "5 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "10 Gram Paketli Granül Gümüş",
          "webKey": "10 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "20 Gram Paketli Granül Gümüş",
          "webKey": "20 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "30 Gram Paketli Granül Gümüş",
          "webKey": "30 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "40 Gram Paketli Granül Gümüş",
          "webKey": "40 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "50 Gram Paketli Granül Gümüş",
          "webKey": "50 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "100 Gram Paketli Granül Gümüş",
          "webKey": "100 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "200 Gram Paketli Granül Gümüş",
          "webKey": "200 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "300 Gram Paketli Granül Gümüş",
          "webKey": "300 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "400 Gram Paketli Granül Gümüş",
          "webKey": "400 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "500 Gram Paketli Granül Gümüş",
          "webKey": "500 Gram Paketli Granül Gümüş"
        },
        {
          "unit": "1 Kilogram Külçe Gümüş",
          "webKey": "1 Kilogram Külçe Gümüş"
        },
        {
          "unit": "GÜMÜŞ TL",
          "webKey": "GÜMÜŞ TL"
        },
        {
          "unit": "GÜMÜŞ USD",
          "webKey": "GÜMÜŞ USD"
        },
        {
          "unit": "GÜMÜŞ ONS",
          "webKey": "GÜMÜŞ ONS",
          "isRaw": true,
          "rawCode": "XAGUSD"
        }
      ]
    },
    "genel": {
      "baslik": "Genel",
      "gorunur": true,
      "birimler": [
        {
          "unit": "24 Ayar",
          "webKey": "24 Ayar"
        },
        {
          "unit": "22 Ayar Bilezik",
          "webKey": "22 Ayar Bilezik"
        },
        {
          "unit": "22 Ayar",
          "webKey": "22 Ayar"
        },
        {
          "unit": "21 Ayar",
          "webKey": "21 Ayar"
        },
        {
          "unit": "18 Ayar",
          "webKey": "18 Ayar"
        },
        {
          "unit": "14 Ayar",
          "webKey": "14 Ayar"
        },
        {
          "unit": "8 Ayar",
          "webKey": "8 Ayar"
        },
        {
          "unit": "ALTIN GÜMÜŞ",
          "webKey": "ALTIN GÜMÜŞ"
        },
        {
          "unit": "GÜMÜŞ TL",
          "webKey": "GÜMÜŞ TL"
        },
        {
          "unit": "GÜMÜŞ USD",
          "webKey": "GÜMÜŞ USD"
        },
        {
          "unit": "GÜMÜŞ ONS",
          "webKey": "GÜMÜŞ ONS",
          "isRaw": true,
          "rawCode": "XAGUSD"
        }
      ]
    }
  },
  "hesapBirimleri": [
    {
      "unit": "Türk Lirası (TRY)",
      "webKey": "TRY"
    },
    {
      "unit": "Eski Ziynet Çeyrek",
      "webKey": "Eski Ziynet Çeyrek"
    },
    {
      "unit": "Yeni Ziynet Çeyrek",
      "webKey": "Yeni Ziynet Çeyrek"
    },
    {
      "unit": "Eski Ziynet Yarım",
      "webKey": "Eski Ziynet Yarım"
    },
    {
      "unit": "Yeni Ziynet Yarım",
      "webKey": "Yeni Ziynet Yarım"
    },
    {
      "unit": "Eski Ziynet Tam",
      "webKey": "Eski Ziynet Tam"
    },
    {
      "unit": "Yeni Ziynet Tam",
      "webKey": "Yeni Ziynet Tam"
    },
    {
      "unit": "Eski Ziynet 2.5'lu Gremse",
      "webKey": "Eski Ziynet 2.5'lu Gremse"
    },
    {
      "unit": "Yeni Ziynet 2.5'lu Gremse",
      "webKey": "Yeni Ziynet 2.5'lu Gremse"
    },
    {
      "unit": "Eski Ziynet Beşli",
      "webKey": "Eski Ziynet Beşli"
    },
    {
      "unit": "Yeni Ziynet Beşli",
      "webKey": "Yeni Ziynet Beşli"
    },
    {
      "unit": "Cumhuriyet Ata Çeyrek",
      "webKey": "Cumhuriyet Ata Çeyrek"
    },
    {
      "unit": "Cumhuriyet Ata Yarım",
      "webKey": "Cumhuriyet Ata Yarım"
    },
    {
      "unit": "Cumhuriyet Ata",
      "webKey": "Cumhuriyet Ata"
    },
    {
      "unit": "Cumhuriyet Ata 2.5'lu",
      "webKey": "Cumhuriyet Ata 2.5'lu Gremse"
    },
    {
      "unit": "Cumhuriyet Ata Beşli",
      "webKey": "Cumhuriyet Ata Beşli"
    },
    {
      "unit": "Reşat",
      "webKey": "Reşat"
    },
    {
      "unit": "Reşat 2.5'lu",
      "webKey": "Reşat 2.5'lu Gremse"
    },
    {
      "unit": "Reşat Beşli",
      "webKey": "Reşat Beşli"
    },
    {
      "unit": "1 Gram 22 Ayar",
      "webKey": "1 Gram 22 Ayar"
    },
    {
      "unit": "0.50 Gram 22 Ayar",
      "webKey": "0.50 Gram 22 Ayar"
    },
    {
      "unit": "0.25 Gram 22 Ayar",
      "webKey": "0.25 Gram 22 Ayar"
    },
    {
      "unit": "1 Gram 24 Ayar",
      "webKey": "1 Gram 24 Ayar"
    },
    {
      "unit": "0.50 Gram 24 Ayar",
      "webKey": "0.50 Gram 24 Ayar"
    },
    {
      "unit": "0.25 Gram 24 Ayar",
      "webKey": "0.25 Gram 24 Ayar"
    },
    {
      "unit": "2.50 Gram 24 Ayar",
      "webKey": "2.50 Gram 24 Ayar"
    },
    {
      "unit": "5 Gram 24 Ayar",
      "webKey": "5 Gram 24 Ayar"
    },
    {
      "unit": "10 Gram 24 Ayar",
      "webKey": "10 Gram 24 Ayar"
    },
    {
      "unit": "20 Gram 24 Ayar",
      "webKey": "20 Gram 24 Ayar"
    },
    {
      "unit": "50 Gram 24 Ayar",
      "webKey": "50 Gram 24 Ayar"
    },
    {
      "unit": "100 Gram 24 Ayar",
      "webKey": "100 Gram 24 Ayar"
    },
    {
      "unit": "24 Ayar (Has)",
      "webKey": "24 Ayar"
    },
    {
      "unit": "22 Ayar Bilezik",
      "webKey": "22 Ayar Bilezik"
    },
    {
      "unit": "22 Ayar Hurda",
      "webKey": "22 Ayar"
    },
    {
      "unit": "21 Ayar Hurda",
      "webKey": "21 Ayar"
    },
    {
      "unit": "18 Ayar Hurda",
      "webKey": "18 Ayar"
    },
    {
      "unit": "14 Ayar Hurda",
      "webKey": "14 Ayar"
    },
    {
      "unit": "8 Ayar Hurda",
      "webKey": "8 Ayar"
    },
    {
      "unit": "Amerikan Doları",
      "webKey": "USD - Amerikan Doları"
    },
    {
      "unit": "Euro",
      "webKey": "EUR - Euro"
    },
    {
      "unit": "Sterlin",
      "webKey": "GBP - İngiliz Sterlini"
    },
    {
      "unit": "İsviçre Frangı",
      "webKey": "CHF - İsviçre Frangı"
    },
    {
      "unit": "Avustralya Doları",
      "webKey": "AUD - Avustralya Doları"
    },
    {
      "unit": "Kanada Doları",
      "webKey": "CAD - Kanada Doları"
    },
    {
      "unit": "Riyal",
      "webKey": "SAR - Suudi Arabistan Riyali"
    },
    {
      "unit": "Gümüş TL",
      "webKey": "GÜMÜŞ TL"
    },
    {
      "unit": "Gümüş USD",
      "webKey": "GÜMÜŞ USD"
    },
    {
      "unit": "Gümüş Ons",
      "webKey": "GÜMÜŞ ONS"
    }
  ],
  "menu": {
    "hakkimizda": {
      "baslik": "Hakkımızda",
      "metin": ""
    },
    "yasalUyari": {
      "baslik": "Yasal Uyarı",
      "metin": ""
    },
    "kvkk": {
      "baslik": "Kişisel Verilerin Korunması",
      "metin": ""
    },
    "magazalar": {
      "baslik": "Mağazalar",
      "subeler": [
        {
          "baslik": "MERKEZ",
          "adres": "Fevzi Çakmak Mahallesi, Sultan Murat Caddesi, No: 64 / A\nSefaköy / Küçükçekmece / İSTANBUL",
          "telefon": "0212 426 35 21"
        },
        {
          "baslik": "ŞUBE",
          "adres": "Fevzi Çakmak Mahallesi, Ahmet Kocabıyık Sokak, No: 17 / D\nSefaköy / Küçükçekmece / İSTANBUL",
          "telefon": "0212 627 24 24"
        },
        {
          "baslik": "ŞUBE",
          "adres": "Kavaklı Mahallesi, Oğuzhan Caddesi, No: 32 / D\nKavaklı / Beylikdüzü / İSTANBUL",
          "telefon": "0212 302 34 44"
        }
      ]
    },
    "iletisim": {
      "baslik": "İletişim",
      "sosyal": [
        { "tip": "instagram", "etiket": "Instagram: ukbagold", "deger": "https://www.instagram.com/ukbagold" },
        { "tip": "youtube", "etiket": "YouTube: ukbagold", "deger": "https://www.youtube.com/@ukbagold" },
        { "tip": "facebook", "etiket": "Facebook: ukbagold", "deger": "https://www.facebook.com/ukbagold" },
        { "tip": "twitter", "etiket": "Twitter: ukbagold", "deger": "https://twitter.com/ukbagold" }
      ],
      "iletisim": [
        { "tip": "web", "etiket": "www.ukbagold.com", "deger": "https://www.ukbagold.com" },
        { "tip": "telefon", "etiket": "Mağaza: 0212 302 34 44", "deger": "02123023444" },
        { "tip": "whatsapp", "etiket": "WhatsApp: 0212 302 34 44", "deger": "https://wa.me/902123023444" },
        { "tip": "eposta", "etiket": "info@ukbagold.com", "deger": "info@ukbagold.com" }
      ]
    }
  }
};

// Ekrandaki sekmeler.
export const SAYFA_TANIMLARI = [
  { anahtar: 'sarrafiye',      baslik: 'Sarrafiye',        tip: 'liste' },
  { anahtar: 'gramAltin',      baslik: 'Gram Altın',       tip: 'liste' },
  { anahtar: 'doviz',          baslik: 'Döviz',            tip: 'liste' },
  { anahtar: 'gumus',          baslik: 'Gümüş',            tip: 'liste' },
  { anahtar: 'genel',          baslik: 'Genel',            tip: 'liste' },
  { anahtar: 'hesapBirimleri', baslik: 'Hesaplama / Zekât / Portföy', tip: 'liste' },
  { anahtar: 'hakkimizda',     baslik: 'Menü: Hakkımızda', tip: 'metin' },
  { anahtar: 'yasalUyari',     baslik: 'Menü: Yasal Uyarı', tip: 'metin' },
  { anahtar: 'kvkk',           baslik: 'Menü: KVKK',       tip: 'metin' },
  { anahtar: 'magazalar',      baslik: 'Menü: Mağazalar',  tip: 'magazalar' },
  { anahtar: 'iletisim',       baslik: 'Menü: İletişim',   tip: 'iletisim' },
];
